/**
 * Updates the cursor style of the canvas based on interaction type and current UI state.
 *
 * This function determines what cursor to display depending on the following conditions:
 * - If the user is hovering a box in "edit" mode, cursor becomes a pointer.
 * - If in "add" mode, cursor becomes a crosshair.
 * - If in "move" mode and dragging is active, cursor becomes grabbing; otherwise, grab.
 * - Defaults to a normal cursor for any other state.
 *
 * @param {Object} options - Configuration options
 * @param {HTMLCanvasElement} options.canvas - The canvas DOM element whose cursor is to be updated.
 * @param {string|null} options.hoveredBoxId - ID of the currently hovered box, if any.
 * @param {boolean} options.isDragging - Whether the canvas is currently being dragged.
 * @param {string} options.type - Current interaction mode: "add", "edit", "move", etc.
 */
export const updateCanvasCursor = ({
  canvas,
  hoveredBoxId,
  isDragging,
  type,
}) => {
  if (!canvas || typeof canvas.style === "undefined") return;

  if (type === "add") {
    canvas.style.cursor = "crosshair";
  } else if (hoveredBoxId) {
    canvas.style.cursor = "pointer";
  } else if (type === "move") {
    canvas.style.cursor = isDragging ? "grabbing" : "grab";
  } else {
    canvas.style.cursor = "default";
  }
};
